import styled from "styled-components";
import TextField from "components/TextField";

export const StyledTextField = styled(TextField)`
  .MuiInputBase-root {
    background-color: white;
  }
`;
